<template>
  <div :style="{ height: pageHeight + 'px' }">
    <div class="myPage">
     <!-- <van-cell value="内容" is-link>
        <template #title>
          <span class="custom-title">单元格</span>
          <van-tag type="danger">标签</van-tag>
        </template>
      </van-cell> -->

    <van-row type="flex" justify="end" align="center" @click="changeUser">
      <van-col span="5">
        <!-- <van-image
          round
          width="65px"
          height="65px"
          :src="imgSrc"
        /> -->
        <van-image width="65px" height="65px" round fit="cover" :src="imgSrc" >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </van-col>
      <van-col span="17" >
        <p class="user">
          <span>{{cpname}}</span>
          <van-button color="#0B7DEC" size="mini" round type="info" v-if="myAccShow">系统维护员</van-button>
        </p>
        <span class="tel" v-if="myAccShow">手机号：{{phoneNum}}</span>
      </van-col>
      <van-col span="2"><i class="van-icon van-icon-arrow van-cell__right-icon userIcon"></i></van-col>
    </van-row>

    </div>
    <div class="mybox" :style="{ height: pageHeight*0.65+20-40+ 'px' }">
      <ul class="myitem">
        <li @click="getCollectMlines">
          <div>
            <img src="../assets/sc-wd@3x.png" alt="">
            <p>收藏线路</p>
            <span>{{CollectMlineCount}}条</span>
          </div>
        </li>
        <li @click="getDayDiares">
          <div>
            <img src="../assets/gz-wd@3x.png" alt="">
            <p>今日故障</p>
            <span>{{DayDiaresCount}}条</span>
          </div>
        </li>
        <li @click="getMlines">
          <div>
            <img src="../assets/xl-wd@3x.png" alt="">
            <p>所属线路</p>
            <span>{{MlineCount}}条</span>
          </div>
        </li>
      </ul>

      <div class="myitem" v-if="myAccShow">
        <van-cell title="账号与安全" icon="zhyaq" is-link @click="TOaccountPage"/>
        <van-cell title="消息通知" icon="xxtz" is-link to="noticyPage"/>
        <van-cell title="注销" icon="zhzx" is-link @click="logout"/>
      </div>

    </div>
     <div class="kftel"><span>客服电话：4001330288</span></div>

  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, Image as VanImage, Cell, CellGroup, Button, Grid, GridItem, Loading, Dialog } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, VanImage, Cell, CellGroup, Button, Grid, GridItem, Loading, Dialog)

export default {
  name: 'myPage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Loading.name]: Loading,
    [Dialog.name]: Dialog,
  },
  data () {
    return {
      imgSrc: '',
      cpname: '', // 姓名
      phoneNum: '', // 手机号
      CollectMlineCount: '', // 收藏线路条数
      DayDiaresCount: '', // 今日故障条数
      MlineCount: '', // 所属线路条数
      // imgSrc: require('../assets/tx@3x.png'),
      pageHeight: window.innerHeight - 50,
      myAccShow:false,
    }
  },
  activated () {
    if (window.config.type===0){
      this.myAccShow = true
      this.getPersonal()// 个人信息
      this.getCollectMlineCount()// 收藏线路条数
     } else {
       this.getAccounts()// 个人信息
       this.getCollectMlineCount2()// 收藏线路条数

     }
    this.imgSrc = `${this.setUserImages()}&v=${Math.random() * 10}`
    
    this.getDayDiaresCount()// 今日故障条数
    this.getMlineCount()// 所属线路条数
  },
  created () {
    // console.log('created')
  },
  mounted () {
     if (window.config.type===0){
      this.myAccShow = true
      this.getPersonal()// 个人信息
      this.getCollectMlineCount()// 收藏线路条数

     } else {
       this.getAccounts()// 个人信息
       this.getCollectMlineCount2()// 收藏线路条数

     }
    this.getDayDiaresCount()// 今日故障条数
    this.getMlineCount()// 所属线路条数
  },
  methods: {
    setUserImages () {
      return window.config.baseUrl+'/showTXImg?phoneNum=' + this.phoneNum// 用户头像接口
    },
    getimgSrc () {
      this.imgSrc = window.config.baseUrl+'/showTXImg?phoneNum=' + this.phoneNum// 用户头像接口
    },
    getPersonal () {
      this.util.post('/getPersonal').then(({ data }) => {
        // console.log(data)
        if (data.code === 200) {
          this.cpname = data.data.cpphoneVO.cpname
          this.phoneNum = data.data.cpphoneVO.phoneNum
          this.imgSrc = `${this.setUserImages()}&v=${Math.random() * 10}`
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getAccounts() {
      this.util.post('/getAccounts', {
        accounts: localStorage.getItem('accounts') 
      }).then(({ data }) => {
        // console.log(data)
        if (data.code === 200) {
          this.cpname = data.data.cpphoneVO.accounts
          this.phoneNum = data.data.cpphoneVO.accounts
          this.imgSrc = `${this.setUserImages()}&v=${Math.random() * 10}`
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getCollectMlineCount () {
      this.util.post('/getCollectMlineCount').then(({ data }) => {
        // console.log(data)
        if (data.code === 200) {
          this.CollectMlineCount = data.data.count
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getCollectMlineCount2() {
      this.util.post('/getCollectMlineCount2').then(({ data }) => {
        // console.log(data)
        if (data.code === 200) {
          this.CollectMlineCount = data.data.count
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getDayDiaresCount () {
      this.util.post('/getDayDiaresCount').then(({ data }) => {
        if (data.code === 200) {
          this.DayDiaresCount = data.data.count
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getMlineCount () {
      this.util.post('/getMlineCount').then(({ data }) => {
        if (data.code === 200) {
          this.MlineCount = data.data.count
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    TOaccountPage () {
      // 跳转到账户与安全页面
      this.$router.push({ path: '/accountPage', query: { phoneNum: this.phoneNum } })
    },
    changeUser () {
      // 跳转到个人信息页面
      this.$router.push({ path: '/changeUserPage', query: { cpname: this.cpname, phoneNum: this.phoneNum } })
    },
    getCollectMlines () {
      this.$router.push({
        path: '/getCollectMlinesPage'// 跳转到收藏线路页
      })
    },
    getDayDiares () {
      this.$router.push({
        path: '/getDayDiaresPage'// 跳转到今日故障页
      })
    },
    getMlines () {
      this.$router.push({
        path: '/getMlinesPage'// 跳转到所属线路页
      })
    },
    logout(){
      Dialog.confirm({
        title: '',
        message: '是否确定注销?',
      })
        .then(() => {
          this.util.post('/logoff').then(({ data }) => {
          if (data.code === 200) {
            this.$router.push({
              path: '/login'
            })
          } else {
            // 验证失败
            // this.util.toast(data.msg)
            return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
          }
        })
        })
        .catch(() => {
          // on cancel
        });
      
      
    },
  },
  computed: {
    // imgSrc () {
    //   let imgSrc = 'http://pwapp.whxzg181.cn/api/showTXImg?phoneNum=' + this.phoneNum// 用户头像接口
    //   return imgSrc
    // }
  }
}
</script>

<style scoped lang="less">
.van-icon-zhyaq{
  width: 20px;
  height: auto;
  margin-right: 13px;
  background: url("../assets/zhyaq-wd@3x.png") no-repeat top center;
  background-size: 100% 100%;
}
.van-icon-xxtz{
  width: 20px;
  height: auto;
  margin-right: 13px;
  background: url("../assets/xxtz-wd@3x.png") no-repeat top center;
  background-size: 100% 100%;
}
.van-icon-zhzx{
  width: 20px;
  height: auto;
  margin-right: 13px;
  background: url("../assets/zhuxiao.png") no-repeat top center;
  background-size: contain;
}
/deep/.van-cell__right-icon {
    color: #EFF7FA;
}
.myitem .van-cell__right-icon{
  color: #A1A1A1;
}
.myitem .van-cell{
  padding: 15px;
}
</style>
